import kvTransition from './kv';
import lowlayerTransition from './lowlayer';

// --------------------------------------------

// -- 画面遷移時のアニメーションを処理

// --------------------------------------------
export default class transitionManager {
    constructor(pageID,effect) {

        this.pageID = pageID;

        this.conf = {
            ease : {
                in : {
                    speed : 0.6,
                    type : "Power2.easeOut"
                },
                singleIn : {
                    speed : 0.6,
                    type : "Power2.easeOut"
                },
                out : {
                    speed : 1,
                    type : "Power2.easeInOut"
                }
            }
        }

        this.kv = new kvTransition(effect,this.conf.ease);
        this.lowlayer = new lowlayerTransition(effect,this.conf.ease);

    }
    init(){

        this.kv.init(this.pageID);
        this.lowlayer.init();

    }
    update(pageID,prevPageID){

        this.pageID = pageID;


        if(pageID!=prevPageID&&prevPageID!="top") this.lowlayer.motion("js__filter-" + prevPageID,"p-"+ prevPageID +"-stage","in");
        if(this.pageID!=="top"){
            // if(pageID!=prevPageID&&prevPageID=="company"){
            //     this.kv.motion("js__filter-" + this.pageID,"singleIn");
            // }else{
            //     this.kv.motion("js__filter-" + this.pageID,"out");
            // }
            this.kv.motion("js__filter-" + this.pageID,"out");
            this.lowlayer.motion("js__filter-" + this.pageID,"p-"+ this.pageID +"-stage","out");
        }else{
            this.kv.motion("js__filter-" + this.pageID,"in");
        }


    }
    render(mouse,scrollInc){

    }
    resize(display){

    }
}